module.exports = __webpack_public_path__ + "assets/img/tab3_02.8bfa16a1.jpg";